import { Dashboard, AssistantInternal, Paths, Runs, MetaApis, Portal, ReportingGroups, AIGroups, GlobalSettings, WorkspaceSettings, Explore, HomePage, PathSynchro, PathReporting, PathDataTable, PathMetaApi, PathAI } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

export const PathSynchroRoute = "pathsynchro"
export const PathReportingRoute = "pathreporting"
export const PathDataTableRoute = "pathdatatable"
export const PathMetaApiRoute = "pathmetaapi"
export const PathAIRoute = "pathai"

const routes = [
    {
        path: '/dashboard',
        element: Dashboard
    },
    {
        path: '/assistant',
        element: AssistantInternal
    },
    {
        path: '/paths',
        element: Paths
    },
    {
        path: '/runs',
        element: Runs
    },
    {
        path: '/metaapis',
        element: MetaApis
    },
    {
        path: '/portal',
        element: Portal
    },
    {
        path: '/reporting-groups',
        element: ReportingGroups
    },
    {
        path: '/ai-groups',
        element: AIGroups
    },
    {
        path: '/global-settings',
        element: GlobalSettings
    },
    {
        path: '/workspace-settings',
        element: WorkspaceSettings
    },
    {
        path: '/explore',
        element: Explore
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/' + PathSynchroRoute + '/:id',
        element: PathSynchro
    },
    {
        path: '/' + PathReportingRoute + '/:id',
        element: PathReporting
    },
    {
        path: '/' + PathDataTableRoute + '/:id',
        element: PathDataTable
    },
    {
        path: '/' + PathMetaApiRoute + '/:id',
        element: PathMetaApi
    },
    {
        path: '/' + PathAIRoute + '/:id',
        element: PathAI
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
